import RequestPage from './RequestPage'
import Landing from './Landing'
import Main from './Main'
import Photographer from './Photographer'
import User from './User'
import Admin from './Admin'

export default [Landing, RequestPage, Main, Photographer, User, Admin]
